import { useQuery } from '@tanstack/react-query';

import { MessageLengthConfig, setChunkLimits } from '../utils/chunk-limits';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

// Runtime message-length limits (in characters) served by the backend at
// GET {apiUrl}/config. Fetched once at app start; the response updates the
// in-memory chunk-limits store consumed by the rule editors. If the request
// fails the store keeps its built-in defaults.
export const getMessageLengthConfig = (): Promise<MessageLengthConfig> => {
  return axios.get('/config');
};

type QueryFnType = typeof getMessageLengthConfig;

type UseMessageLengthConfigOptions = {
  config?: QueryConfig<QueryFnType>;
};

export function useMessageLengthConfig({ config }: UseMessageLengthConfigOptions = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['message-length-config'],
    queryFn: getMessageLengthConfig,
    onSuccess: (data) => setChunkLimits(data),
    ...config,
  });
}
